var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsSmallPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    transform: "rotate(-45 24 24)",
    cx: 24,
    cy: 24,
    r: 16.971
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.46 24.005-11.077-7.258v14.57l11.077-7.312z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSmallPlay);
export default __webpack_public_path__ + "static/media/icons-small-play.9573029ea381e1aa95b0a223ba7dc627.svg";
export { ForwardRef as ReactComponent };